export const formatPhoneNumber = (phoneNumber, parenthesis = true) => {
  let countryCode = '';
  let num = phoneNumber.replace(/\D/g, '');
  if (num[0] === '1') {
    countryCode = '1 ';
    num = num.slice(1);
  }
  if (num.length === 0) {
    return countryCode.trim();
  }
  if (num.length < 4) {
    return `${countryCode}${num}`;
  }
  if (num.length < 7) {
    return `${countryCode}(${num.slice(0, 3)}) ${num.slice(3)}`;
  }
  return parenthesis ? `${countryCode}(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}` : `${countryCode}${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 10)}`;
};
